import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import AthleteRegistrationForm from './pages/AthleteRegistrationForm';
import PaymentPage from './pages/PaymentPage';
import Login from './pages/Login';
import Success from './pages/Success';
import Dashboard from './pages/Dashboard';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AdminLogin from './pages/AdminLogin';
import AthletesList from './pages/AthletesList';
import { ToastContainer } from 'react-toastify';


const theme = createTheme({
  palette: {
    primary: {
      main: '#291e6c',
      dark: '#1f1750',
    },
    secondary: {
      main: '#a70000',
    },
    error: {
      main: '#DB162A',
    },
    warning: {
      main: '#FEED00',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#2c3e50',
      secondary: '#7f8c8d',
    },
  },
  typography: {
    fontFamily: "'Oswald', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h2: {
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 800,
    },
    h3: {
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 700,
    },
    h5: {
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 700,
    },
    h6: {
      fontFamily: "'Oswald', sans-serif",
      fontWeight: 600,
    },
    button: {
      fontFamily: "'Oswald', sans-serif",
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontSize: '1rem',
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

// Protected Route for Admin
const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading: isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

// Protected Route for Athlete
const AthleteRoute = ({ children }) => {
  const { isAuthenticated, isAthlete, loading } = useAuth();
  console.log(isAuthenticated);
  console.log(isAthlete);
  if (loading) {
    return <div>Loading...</div>;
  }

  // if (!isAuthenticated) {
  //   return <Navigate to="/login" replace />;
  // }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Toaster position="top-right" />
          <Header/>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/register" replace />} />
            <Route
              path="/register"
              element={<AthleteRegistrationForm />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/success" element={<Success />} />

            {/* Athlete Protected Routes */}
            <Route
              path="/dashboard"
              element={
                <AthleteRoute>
                  <Dashboard />
                </AthleteRoute>
              }
            />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/athletes"
              element={
                <AdminRoute>
                  <AthletesList />
                </AdminRoute>
              }
            />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/register" replace />} />
          </Routes>
          <Footer/>
        </Router>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;